import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive, watch } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue'
import Property from '@/views/middleGround/member/property.vue'
import CommunityBusinesses from '@/views/middleGround/member/communityBusinesses.vue'
import BrandManufacturers from '@/views/middleGround/member/brandManufacturers.vue'
import { defineComponent } from "vue";
import { shallowReactive } from "vue";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const ustore = useStore();

    var bindData = shallowReactive({
        loginMember: ustore.state.loginMember==undefined ? {} : ustore.state.loginMember,
        memberType: ustore.state.loginMember==undefined ? 0 : ustore.state.loginMember.type
    });

    watch(() => ustore.state.loginMember, (newValue: any , oldValue: any) =>{
        bindData.loginMember = newValue;
        bindData.memberType = newValue.type;
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(bindData).memberType==1)
      ? (_openBlock(), _createBlock(Property, { key: 0 }))
      : (_unref(bindData).memberType==2)
        ? (_openBlock(), _createBlock(BrandManufacturers, { key: 1 }))
        : (_unref(bindData).memberType==3)
          ? (_openBlock(), _createBlock(CommunityBusinesses, { key: 2 }))
          : _createCommentVNode("", true)
  ]))
}
}

})